var exports = {
  "standard": "xf0b3b88a--04d2c8--standard",
  "light": "xf0b3b88a--04d2c8--light",
  "outline": "xf0b3b88a--04d2c8--outline",
};

module.exports = exports;
